import React, { useEffect, useState, Fragment } from "react";
import { Button, Checkbox, Form, Input, Select, Row } from "antd";
import { Link, useHistory } from "react-router-dom";
import OtpInput from "react-otp-input";
import queryString from "query-string";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";

import { useDispatch, useSelector } from "react-redux";
import {
  hideMessage,
  showAuthLoader,
  userSignUp,
  createCognitoUser,
  verifyUserPhoneNumber,
  verifyCognitoOtp,
  resetAuthStore,
} from "./../appRedux/actions/Auth";

import IntlMessages from "util/IntlMessages";
import { message } from "antd/lib/index";
import CircularProgress from "components/CircularProgress/index";
import PhoneNumber from "../routes/components/dataEntry/Form/PhoneNumber";
import { Option } from "antd/lib/mentions";
import { GRADES } from "../constants/AppConstants";

const FormItem = Form.Item;

const SignUp = ({ location }) => {
  console.log(location);
  const dispatch = useDispatch();
  const history = useHistory();
  // let location = useLocation();
  const {
    loader,
    alertMessage,
    showMessage,
    authUser,
    cognitoUser,
    showOTP,
  } = useSelector(({ auth }) => auth);
  const [otp, setOtp] = useState("");
  const [schoolId, setSchoolId] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [termsAgreed, setTermAgreed] = useState(false);
  const [form] = Form.useForm();
  useEffect(() => {
    if (showMessage) {
      setTimeout(() => {
        dispatch(hideMessage());
      }, 100);
    }
    if (authUser !== null && authUser.username) {
      history.push("/");
    }
    // dispatch(hideMessage());
  });

  const search_params = queryString.parse(location.search);
  const { school_id, school_name } = search_params;
  useEffect(() => {
    dispatch(resetAuthStore);
    console.log(location)
  }, []);
  useEffect(() => {
    setSchoolId(school_id);
    setSchoolName(school_name);
  });

  useEffect(() => {
    if (!showMessage || !alertMessage) return;
    if (alertMessage.toString().indexOf("exists") !== -1) {
      return NotificationManager.error(
        <Fragment>
          <span>Account with number already exists. Check the number again or try logging in instead </span>
          <br></br>
          <Link
            to="/signin"
            onClick={() => {
              dispatch(resetAuthStore());
            }}
          >
            <h2>Login</h2>
          </Link>
        </Fragment>
      );
    }
    return NotificationManager.error(
      <span>{alertMessage ? alertMessage.toString() : ""}</span>
    );
  }, [showMessage]);
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    // console.log("updated url")
    // console.log(location.pathname+`${location.search}&phone=${values.phone}`)
    history.push(location.pathname+`${location.search}&phone=${values.phone}`)
    dispatch(showAuthLoader());
    if (showOTP) {
      return dispatch(verifyCognitoOtp({ cognitoUser, otp }));
    }
    if (!school_id) {
      return dispatch(showMessage("Please Select school to register"));
    }
    dispatch(createCognitoUser(values));
  };
  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-bg">
              <img
                src={require("assets/images/bg-website-final.png")}
                alt="background"
              />
            </div>
            <div className="gx-app-logo-wid">
              {showOTP ? (
                <h1>
                  <IntlMessages id={"app.userAuth.verifyOtp"} />
                </h1>
              ) : (
                <h1>
                  <IntlMessages id={"app.userAuth.signUp"} />
                </h1>
              )}
              <p>
                <IntlMessages id="app.userAuth.bySigning" />
              </p>
              <p>
                <IntlMessages id="app.userAuth.getAccount" />
              </p>
            </div>
            <div className="gx-app-logo">
              <img
                alt="example"
                src={require("assets/images/quiznext-logo-white@2x.png")}
              />
            </div>
          </div>

          <div className="gx-app-login-content">
            <Form
              form={form}
              initialValues={{
                first_name: "",
                phone: "",
                board: "CBSE",
                grade: GRADES[0],
                school_id: school_id,
                school_name: school_name,
              }}
              name="basic"
              onInvalid={(v) => console.log(v)}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0"
            >
              {!showOTP && (
                <Fragment>
                  <FormItem
                    rules={[
                      {
                        required: true,
                        message: "Please input your first name!",
                      },
                    ]}
                    name="first_name"
                  >
                    <Input placeholder="First Name" />
                  </FormItem>
                  <FormItem rules={[{ required: false }]} name="last_name">
                    <Input placeholder="Last Name" />
                  </FormItem>
                  <Form.Item name='email'  rules={[{ type: 'email' }]}>
                    <Input placeholder="Email"/>
                  </Form.Item>
                  <FormItem rules={[{ required: true }]} name="school_name">
                    <Input
                      placeholder="Select School"
                      defaultValue={school_name}
                      disabled
                      allowClear
                    />
                    <div
                      style={{ display: "flex", flexDirection: "row-reverse" }}
                    >
                      <Link
                        to={{
                          pathname: "/schools",
                        }}
                      >
                        {!school_id ? "Select school" : ""}
                      </Link>
                    </div>
                  </FormItem>

                  <FormItem
                    rules={[{ required: true }]}
                    name="school_id"
                    hidden
                  >
                    <Input
                      placeholder="Select School"
                      defaultValue={school_id}
                    />
                  </FormItem>
                  <PhoneNumber formRef={form}/>
                </Fragment>
              )}
              {showOTP && (
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  separator={<span style={{ padding: "3" }}>-</span>}
                  inputStyle={{ minWidth: "30px", minHeight: "30px" }}
                />
              )}
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "You must agree to terms of service to continue.",
                    transform: () => {
                      return termsAgreed ? "checked" : "";
                    },
                  },
                ]}
                name="terms"
                validateStatus={termsAgreed ? "success" : "error"}
              >
                <Input
                  type="checkbox"
                  onClick={(e) => {
                    console.log(e);
                    setTermAgreed(!termsAgreed);
                  }}
                />
                <span style={{ paddingLeft: 15, paddingBottom: 15 }}>
                  <span>
                    <IntlMessages id="appModule.iAccept" />
                  </span>
                  <a
                    target="_blank"
                    href="https://quiznextpublic.s3.ap-south-1.amazonaws.com/terms_of_use.htm"
                  >
                    <span className="gx-signup-form-forgot gx-link">
                      &nbsp;
                      <IntlMessages id="appModule.termAndCondition" />
                    </span>
                  </a>
                </span>
              </Form.Item>
              <FormItem>
                <Button type="primary" className="gx-mb-0" htmlType="submit">
                  {showOTP ? (
                    <IntlMessages id={"app.userAuth.verifyOtp"} />
                  ) : (
                    "Register"
                  )}
                </Button>
                <span>
                  <IntlMessages id="app.userAuth.or" />
                </span>{" "}
                <Link
                  to="/signin"
                  onClick={() => {
                    dispatch(resetAuthStore());
                  }}
                >
                  Login
                </Link>
              </FormItem>
            </Form>
            <Link
              onClick={() => {
                window.tidioChatApi && window.tidioChatApi.popUpOpen();

              }}
            >
              Need help with signup?
            </Link>
          </div>
          {loader && (
            <div className="gx-loader-view">
              <CircularProgress />
            </div>
          )}
          {/* {showMessage ?
            message.error(alertMessage.toString(),5) : null} */}
          <div style={{ zIndex: 100000 }}>
            <NotificationContainer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
